// 设备管理接口
import request from '@/utils/request'

export const getdatalist = (params: any) =>
  request({
    url: '/judgement/getJudgementInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getdatalist = (params: any) =>
//   request({
//     url: '/api/ratsheetmanage',
//     method: 'get',
//     params
//   })

// export const addratsheet = (params: any) =>
//   request({
//     url: '/api/ratsheetmanage',
//     method: 'post',
//     data: params
//   })
export const addratsheet = (params: any) =>
  request({
    url: '/judgement/addJudgementInfo',
    method: 'post',
    data: params
  })
export const getorgytype = (params: any) =>
  request({
    url: '/organization/organListByID',
    method: 'post',
    data: params
  })


// export const getdatainfo = (params: any) =>
//   request({
//     url: '/api/ratsheetmanage/:id',
//     method: 'get',
//     params
//   })
export const getdatainfo = (params: any) =>
  request({
    url: '/judgement/getJudgementInfoById',
    method: 'post',
    data: params
  })

// export const changedatainfo = (params: any) =>
//   request({
//     url: '/api/ratsheetmanage',
//     method: 'put',
//     data: params
//   })
export const changedatainfo = (params: any) =>
  request({
    url: '/judgement/updateInfo',
    method: 'put',
    data: params
  })
export const getAnalizelist = (params: any) =>
  request({
    url: '/judgement/getInfoCondition',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const removelotData = (params: any) =>
  request({
    url: '/judgement/removeInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getAnalizelist = (params: any) =>
//   request({
//     url: '/api/ratsheetmanagetype',
//     method: 'post',
//     data: params
//   })
// export const getdetail = (params: any) =>
//   request({
//     url: '/api/ratsheetmanagedetail',
//     method: 'get',
//     params
//   })
export const getdetail = (params: any) =>
  request({
    url: '/judgement/getJudgeDetail',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const upLoadFile = (params: any) =>
//   request({
//     url: '/api/ratsheetmanage/:file',
//     method: 'post',
//     data: params
//   })
export const upLoadFile = (params: any) =>
  request({
    url: '/judgement/uploadfile',
    method: 'post',
    data: params
  })

export const getinjurylist = (params: any) =>
  request({
    url: '/injurydetails/getlistbycondition',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
